export const OpenInStayinUtils = {
  data () {
    return {
      showMenu: false
    }
  },
  computed: {
    canOpenInStayin () {
      return this.hasAnyPermission('OPEN_IN_STAYIN');
    }
  },
  methods: {
    openMenu () {
      if (this.canOpenInStayin) {
        this.showMenu = true;
      }
    },

    openInStayin () {
      console.warn('Needs to be overwritten');
    },

    getLinkTitle (title) {
      let linkTitle = title;

      if (this.canOpenInStayin) {
        linkTitle += ' (' + this.trans('general.rightClickForMoreOptions') + ')';
      }
      return linkTitle;
    }
  }
};
